import { AlloCationBySourceTable } from "./allocationbysourcetable"
import { DistributionOfExpensesbyCategoryTable } from "./distributionofexpensesbycategory";
import { DynamicsExpenditureTable } from "./dynamicsexpenditure";
import { useGetFinanceAnalyticalDataQuery } from "./api"; 
import { FinanceBlockProps, ApiResponse } from "./types";
import { useTranslation } from 'react-i18next';
import { Button, Flex, message, Modal, Spin, Tooltip, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useReportFinancialIndicatorsMutation } from "../../../../redux/api/financialIndicatorsApi";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/root/root-state.interface";
import style from './style.module.css';
import { GeneralData } from "../..";

export const FinanceBlock: React.FC<FinanceBlockProps> = ({ alias }) => {
    const { t } = useTranslation();
    const [modal, contextHolder] = Modal.useModal();
    const { i18n } = useTranslation();
    const { data: apiData} = useGetFinanceAnalyticalDataQuery(alias) as { data?: ApiResponse };
    const [getReportFinancialIndicators] = useReportFinancialIndicatorsMutation();
    const authState = useSelector((state: RootState) => state.authSlice);

    
    const handleSubmit = async () => {
        try {
          const payload = {
            governmentAlias: alias,
            language: i18n.language,
          };
    
          const result = await getReportFinancialIndicators(payload);
    
          if ('data' in result) {
            const blob = result.data; 
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Отчет_по_финансам.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
    
            message.success(t('reports.download_success'));
          } else {
            throw new Error(t('reports.download_failed'));
          }
        } catch (error: any) {
          Modal.error({
            title: t("msg.error"),
            content: error.message || t('reports.download_failed'),
          });
        }
      };
    const financeData = apiData?.success && Array.isArray(apiData.res)
        ? apiData.res
        : [];

        const governmentName = apiData?.success && apiData.res?.length > 0
        ? i18n.language === 'ru'
          ? apiData.res[0].government?.nameRu
          : apiData.res[0].government?.nameKy
        : 'Данные отсутствуют';

        
    return (
        <div className={style.container}>
            <div className={style.container_inner}>
            <div className={style.title}>
                    <h1>{t('Financial indicators')} - {governmentName || t('Data not available')}</h1>
                    <Button style={{marginLeft: '5px'}} type="primary" icon={<img src="../../../report.svg" alt="Plus Icon" style={{ width: '16px', height: '16px' }} />}  onClick={() => handleSubmit()}>
        { t('reports.download_report') }
      </Button>
                </div>
                <div className={style.topRow}>
                    <AlloCationBySourceTable data={financeData} />
                    <DistributionOfExpensesbyCategoryTable data={financeData} />
                </div>
                <DynamicsExpenditureTable data={financeData} />
            </div>
        </div>
    );
}
function dayjs() {
    throw new Error("Function not implemented.");
}
